import React from 'react'
import { TableStateType } from 'core/components/data/table/TableTypes'

const EmptyStateOverlay = ({ emptyState }: { emptyState: TableStateType }) => {
  return (
    <div className="h-[34rem] grid place-items-center">
      <div className="flex justify-center flex-col items-center gap-3 mb-10">
        {emptyState?.icon}
        {emptyState?.title && (
          <span className="text-dark font-semibold  mt-4">
            {emptyState.title}
          </span>
        )}
        {emptyState?.subtitle && (
          <span className="text-dark-4 text-base">{emptyState.subtitle}</span>
        )}
        {emptyState?.content && <div className="">{emptyState.content}</div>}
      </div>
    </div>
  )
}
export default EmptyStateOverlay
